var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDishProductsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5447 53H7.79175V58.2529H65.5447V53Z",
    fill: "#2699D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7085 43.9583V49.5H62.6281V43.9583C62.6281 30.7195 52.7085 19.6333 39.5514 18.172L39.2947 18.14V12.1666H34.0418V18.14L33.7852 18.172C20.6281 19.6362 10.7085 30.7225 10.7085 43.9583ZM36.6668 23.2529C48.0856 23.2529 57.3752 32.5425 57.3752 43.9612V44.25H15.9614V43.9583C15.9614 32.5395 25.2481 23.2529 36.6668 23.2529Z",
    fill: "#2699D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDishProductsBlue);
export default __webpack_public_path__ + "static/media/icons-dish-products-blue.1cb09e72a18c06dc36989fbf01c2328c.svg";
export { ForwardRef as ReactComponent };